/**
 * Compra rápida en la tarjeta PLP (Task A6, guía SS25 pág. 17).
 *
 * Un solo script global cargado con `defer` desde las secciones que
 * renderizan `snippets/card-product.liquid` dentro de un grid (colección,
 * home, búsqueda, relacionados — ver comentarios en cada sección). Usa
 * delegación de eventos sobre `document`, así que funciona sin importar en
 * qué sección(es) se haya incluido la etiqueta <script> ni cuántas tarjetas
 * haya en la página. Deliberadamente NO se carga en el cart-drawer ni en
 * el upsell del carrito (assets/timberland-cart-upsell.js): ahí no se
 * renderiza `card-product`, así que no hay `[data-quick-add]` que atender.
 *
 * Mismo patrón que assets/timberland-cart-upsell.js para abrir el drawer:
 * POST a /cart/add.js pidiendo las secciones 'cart-drawer,cart-icon-bubble'
 * y, si existe <cart-drawer>, se le pasa la respuesta cruda tal cual a
 * drawer.renderContents() (misma firma que usa assets/product-form.js:
 * `this.cart.renderContents(response)`). renderContents() ya se encarga de
 * reemplazar el contenido, actualizar la burbuja y abrir el drawer — no
 * hace falta duplicar esa lógica aquí. El aria-live de la apertura lo cubre
 * el propio drawer/cart-notification, no este script.
 */
(() => {
  if (window.__tblQuickAddInit) return;
  window.__tblQuickAddInit = true;

  const RESET_EXITO_MS = 900;
  const RESET_ERROR_MS = 3000;

  // Nota: los botones realmente agotados (variant.available == false) se
  // renderizan con el atributo `disabled` desde Liquid, así que el navegador
  // nunca dispara `click` sobre ellos — restaurar() solo corre para clics
  // reales, siempre es seguro reactivarlos aquí.
  const restaurar = (btn, textoOriginal) => {
    btn.classList.remove('is-loading', 'is-success');
    btn.textContent = textoOriginal;
    btn.disabled = false;
  };

  const mostrarEstadoTemporal = (btn, textoOriginal, texto, ms) => {
    btn.classList.remove('is-loading');
    if (texto) btn.textContent = texto;
    setTimeout(() => restaurar(btn, textoOriginal), ms);
  };

  const agregarAlCarrito = async (btn) => {
    // Protección de doble clic: disabled síncrono antes de cualquier await.
    if (btn.disabled) return;
    const wrapper = btn.closest('[data-quick-add]');
    const textoOriginal = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');

    let data;
    try {
      const respuesta = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble',
        }),
      });
      data = await respuesta.json();
      if (!respuesta.ok) {
        // Caso esperado: la talla se agotó en carrera (otro cliente la
        // compró entre el render de la tarjeta y este clic).
        mostrarEstadoTemporal(btn, textoOriginal, wrapper?.dataset.textoAgotado, RESET_ERROR_MS);
        return;
      }
    } catch (e) {
      // Fallo de red / respuesta no-JSON: no es lo mismo que "agotado",
      // por eso usa su propio texto (timberland.plp.error).
      mostrarEstadoTemporal(btn, textoOriginal, wrapper?.dataset.textoError, RESET_ERROR_MS);
      return;
    }

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
      // Mismo fix que assets/product-form.js:115: si es el primer add de la
      // sesión el drawer todavía trae la clase is-empty (oculta la cabecera
      // y el botón de cerrar vía CSS) y drawer.renderContents() nunca la
      // quita por sí solo -> el contenido nuevo se renderiza sin cabecera,
      // desbordado, y trapFocus() revienta con un TypeError al no encontrar
      // elementos enfocables. Hay que quitarla ANTES de renderContents().
      if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } else {
      // Sin cart-drawer en la página (no debería pasar en este tema, pero
      // por si acaso): el ítem ya se agregó, se refleja recargando.
      window.location.reload();
      return;
    }

    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
    if (wrapper?.dataset.textoAgregado) btn.textContent = wrapper.dataset.textoAgregado;
    setTimeout(() => restaurar(btn, textoOriginal), RESET_EXITO_MS);
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-quick-add-size]');
    if (!btn) return;
    agregarAlCarrito(btn);
  });
})();
